// src/pages/Appli/AppliAdmin/Prospects/components/ProspectsFilters.jsx
import React from "react";

export function ProspectsFilters({
  searchTerm, setSearchTerm,
  selectedStatut, setSelectedStatut,
  selectedProvenance, setSelectedProvenance,
  selectedAssociation, setSelectedAssociation,
  selectedProduct, setSelectedProduct,
  sortBy, setSortBy,
  statuts, provenances, associations, produits,
  onReset,
  viewMode, setViewMode,
  totalCount,
}) {
  return (
    <div className="grid grid-cols-1 md:grid-cols-12 gap-3">
      <input
        className="md:col-span-3 px-3 py-2 rounded-lg border border-slate-200 dark:border-slate-700 bg-white dark:bg-slate-800"
        type="text"
        placeholder="Rechercher (nom, asso, email, produit)…"
        value={searchTerm}
        onChange={(e) => setSearchTerm(e.target.value)}
      />

      <select
        className="md:col-span-2 px-3 py-2 rounded-lg border border-slate-200 dark:border-slate-700 bg-white dark:bg-slate-800"
        value={selectedStatut}
        onChange={(e) => setSelectedStatut(e.target.value)}
      >
        <option value="">Tous les statuts</option>
        {statuts.map((s) => (
          <option key={s} value={s}>{s}</option>
        ))}
      </select>

      <select
        className="md:col-span-2 px-3 py-2 rounded-lg border border-slate-200 dark:border-slate-700 bg-white dark:bg-slate-800"
        value={selectedProvenance}
        onChange={(e) => setSelectedProvenance(e.target.value)}
      >
        <option value="">Toutes provenances</option>
        {provenances.map((p) => (
          <option key={p} value={p}>{p}</option>
        ))}
      </select>

      <select
        className="md:col-span-2 px-3 py-2 rounded-lg border border-slate-200 dark:border-slate-700 bg-white dark:bg-slate-800"
        value={selectedAssociation}
        onChange={(e) => setSelectedAssociation(e.target.value)}
      >
        <option value="">Toutes associations</option>
        {associations.map((a) => (
          <option key={a.id} value={a.id}>{a.nom}</option>
        ))}
      </select>

      <select
        className="md:col-span-2 px-3 py-2 rounded-lg border border-slate-200 dark:border-slate-700 bg-white dark:bg-slate-800"
        value={selectedProduct}
        onChange={(e) => setSelectedProduct(e.target.value)}
      >
        <option value="">Tous produits</option>
        {produits.map((p) => (
          <option key={p.id} value={p.id}>{p.nom}</option>
        ))}
      </select>

      <div className="md:col-span-12 grid grid-cols-2 md:grid-cols-6 gap-3">
        <select
          className="px-3 py-2 rounded-lg border border-slate-200 dark:border-slate-700 bg-white dark:bg-slate-800"
          value={sortBy}
          onChange={(e) => setSortBy(e.target.value)}
        >
          <option value="statut">Trier par statut</option>
          <option value="nom">Trier par nom</option>
          <option value="date">Plus récent d’abord</option>
        </select>

        <select
          className="px-3 py-2 rounded-lg border border-slate-200 dark:border-slate-700 bg-white dark:bg-slate-800"
          value={viewMode}
          onChange={(e) => setViewMode(e.target.value)}
        >
          <option value="auto">Vue auto (table/cards)</option>
          <option value="table">Vue Table</option>
          <option value="cards">Vue Cards</option>
          <option value="kanban">Vue Kanban</option>
        </select>

        <div className="col-span-2 md:col-span-3 flex items-center justify-end gap-2">
          <button
            type="button"
            onClick={onReset}
            className="px-3 py-2 rounded-lg border border-slate-200 dark:border-slate-700 bg-white dark:bg-slate-800"
          >
            Réinitialiser
          </button>
          <div className="text-sm text-slate-500 dark:text-slate-400">
            {totalCount} résultats
          </div>
        </div>
      </div>
    </div>
  );
}
